import { ethers } from 'ethers';

// ABI MÍNIMA — SÓ O QUE PRECISA (evita erros de ABI errada)
const ABI = [
    "function submitProofX(bytes32 proofHash) external",
    "event ExistenceProven(address indexed user, bytes32 proofHash)"
];

const CONTRACT_ADDRESS = '0x9b1DA3FDC56276eF3d5aAA1F478AE34364c707D3';

export const submitProofX = async (message = 'aquiAgora') => {
    if (!window.ethereum) throw new Error('MetaMask não detectada');

    const provider = new ethers.BrowserProvider(window.ethereum);
    const signer = await provider.getSigner();
    const userAddress = await signer.getAddress();

    const contract = new ethers.Contract(CONTRACT_ADDRESS, ABI, signer);

    const proofHash = ethers.keccak256(ethers.toUtf8Bytes(message));

    console.log('Enviando prova de existência...', { userAddress, message, proofHash: proofHash.toString() });

    const tx = await contract.submitProofX(proofHash);
    console.log('Transação enviada, aguardando confirmação...');

    try {
        const receipt = await tx.wait();
        console.log('Prova registrada com sucesso!', receipt.hash);

        return {
            tx: receipt,
            hash: receipt.hash,
            proofHash: proofHash.toString(),
            userAddress,
            message
        };
    } catch (err) {
        console.error('Erro ao registrar prova:', err);
        if (err.message?.includes('RPC') || err.message?.includes('coalesce') || err.message?.includes('endpoint')) {
            throw new Error('Erro de Conexão Blockchain: O servidor RPC da Polygon está instável ou indisponível (ex: lava.build). Por favor, troque o RPC na sua MetaMask para: https://rpc.ankr.com/polygon');
        }
        throw err;
    }
};
